<res-patent-documentation-link></res-patent-documentation-link>
<h1 *ngIf="!patent.id">
	{{ patent.priorityPatent ? ('fs.res.patent.priorityClaim.create' | hisUi) : ('fs.res.patent.priorityPatent.create' | hisUi) }}
</h1>
<h1 *ngIf="patent.id">
	{{ patent.priorityPatent ? ('fs.res.patent.priorityClaim.edit' | hisUi) : ('fs.res.patent.priorityPatent.edit' | hisUi) }}
</h1>
<his-dialog-header [showBackButton]="showBackButton" [showSearchButton]="showSearchButton" (save)="save()" (resetInputs)="reset()">
	<ng-container *ngIf="patent.id" dataBox>
		<span id="patent_id" title="{{'fs.res.patent.Patent.patentNumber'|hisUi}}"><strong>{{patent.patentNumber}}</strong></span>
		| <span class="singleLine" id="patent_id2" title="{{'fs.res.patent.Patent.title'|hisUi}}">{{patent.title}}</span>
	</ng-container>

 	<ng-container elementsRight>
		<his-translation-selector [defaultLanguage]="patent.language"></his-translation-selector>
	</ng-container>
</his-dialog-header>
<br/>

<!-- Tabs -->
<p-tabView>
	<ng-container *ngFor="let tab of tabMenuItems let i = index">
		<ng-container *ngIf="!tab.isDynamic; else dynamicTab">
		    <p-tabPanel lazy="true" [selected]="i === selectedIndex" [header]="tab.i18nKey|hisUi">
		    <res-info-panel [i18nKey]="tab.i18nKey" [target]="'patent'"></res-info-panel>
		        <ng-template pTemplate="header">
		        	<span class="p-tabview-title">{{ tab.i18nKey | hisUi }}</span>
		        </ng-template>
		       <!-- main data -->
		        <div *ngIf="tab.i18nKey === 'fs.res.common.mainData'">
					<res-patent-edit-basic-data-tab [patent]="patent"
						[hisDynamicContent]="'fs.res.common.mainData'" 
						[dynamicComponent]="patent._dynamicComponent"
						[documentsToSave]="documentsToSave">
					</res-patent-edit-basic-data-tab>
				</div>
				<!-- classification -->
				<div *ngIf="tab.i18nKey === 'fs.res.common.classifications'">
					<res-patent-edit-classification-tab [patent]="patent"
						[hisDynamicContent]="'fs.res.common.classifications'" 
						[dynamicComponent]="patent._dynamicComponent">
					</res-patent-edit-classification-tab>
				</div>
				<!-- research /projects -->
				<div *ngIf="tab.i18nKey === 'fs.res.common.research'">
					<res-patent-research-tab [(patent)]="patent"
						[hisDynamicContent]="'fs.res.common.research'" 
						[dynamicComponent]="patent._dynamicComponent">
					</res-patent-research-tab>
				</div>
				<!-- finance -->
				<div *ngIf="tab.i18nKey === 'fs.res.patent.tab.financialData'">
					<res-patent-edit-finance-tab [patent]="patent"
						[hisDynamicContent]="'fs.res.patent.tab.financialData'" 
						[dynamicComponent]="patent._dynamicComponent">
					</res-patent-edit-finance-tab>
				</div>
		    </p-tabPanel>
	    </ng-container>

    	<!-- dynamic content -->
	    <ng-template #dynamicTab>
			<p-tabPanel lazy="true" [selected]="i === selectedIndex" *ngIf="hisBaseGlobalsService.isAnyModuleActive('HISINONERES')" [header]="tab.i18nKey|hisUi">
			 	<ng-template pTemplate="header">
		        	<span class="p-tabview-title">{{ tab.i18nKey | hisUi }}</span>
		        </ng-template> 
		        <res-dynamic-tab-container
                    [objectDynamicContent]="patent"
                    [hisDynamicContent]="tab.i18nKey"
                    [reloadTrigger]="reloadTrigger"
                    [dynamicComponent]="patent._dynamicComponent"
                    [target]="'patent'">
                    <res-patent-view-dynamicfields customStaticContent
                        [patent]="patent" 
                        [dynamicContentTabName]="tab.i18nKey">
                    </res-patent-view-dynamicfields>
                </res-dynamic-tab-container>
			 </p-tabPanel>
	    </ng-template>
    </ng-container>
</p-tabView>
